import React from 'react'
import { observer } from 'mobx-react'
import { toastStore } from './store'
import {
	Toast,
	ToastDescription,
	ToastProvider as ShadcnToastProvider,
	ToastViewport,
} from '@/components/ui/toast'
import { ToastHeader } from '@app/ToastProvider/syles'

export const ToastProvider: React.FC = observer(() => {
	if (!toastStore.showAlert) return null

	const { header, message } = toastStore.alertInfo

	return (
		<ShadcnToastProvider>
			<Toast>
				<ToastHeader>{header}</ToastHeader>
				<ToastDescription>{message}</ToastDescription>
			</Toast>
			<ToastViewport />
		</ShadcnToastProvider>
	)
})
